import {
  type HotkeyCallback,
  type RegisterableHotkey,
  type UseHotkeyOptions,
  useHotkey,
} from '@tanstack/react-hotkeys';
import { useAreGlobalHotkeysEnabled } from './useAreGlobalHotkeysEnabled';

/**
 * Registers a global keyboard shortcut that any surface can suppress with
 * `useDisableGlobalHotkeys` — modals & menus do so automatically.
 *
 * Call this instead of `useHotkey` for shortcuts that act on the app as a
 * whole. Call `useHotkey` directly for shortcuts scoped to a component
 * lifecycle, or for shortcuts scoped to an element via its `target` option.
 */
export function useGlobalHotkey(
  hotkey: RegisterableHotkey,
  callback: HotkeyCallback,
  options: UseHotkeyOptions = {},
): void {
  const areGlobalHotkeysEnabled = useAreGlobalHotkeysEnabled();

  useHotkey(hotkey, callback, {
    ...options,
    enabled: (options.enabled ?? true) && areGlobalHotkeysEnabled,
  });
}
